import { authUserApi } from "../../api";

const AuthUserService = {
  /**
   * 🔐 Obtener roles del usuario autenticado
   * GET /api/auth/user/roles
   */
  getRoles: async () => {
    const response = await authUserApi.fetchCustom("/roles");
    return response.data; 
  },
};

export default AuthUserService;
